import { useContext, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../common/Context";
import { blue, green, purple, white } from "../../../../../theme/colours";
import { TicketIcon } from "../../../../common/Icons";

const GrandPrizeInfoArea = ({
  gp,
  rerender,
  setRerender,
  setDialogInfo,
  setOpenDialog,
  inCarousel,
}) => {
  const { t } = useTranslation("CompetitionInfo");
  const { mobileView, tabletView, desktopView } = useContext(GlobalContext);

  const [gpTitleRef, setGpTitleRef] = useState(null);
  const [gpDescRef, setGpDescRef] = useState(null);

  const handleLearnMore = () => {
    setDialogInfo((prevState) => ({
      ...prevState,
      prize: { title: gp.name, description: gp.description },
    }));
    setOpenDialog(1);
  };

  useEffect(() => {
    if (!gpTitleRef) return;
    if (!gpTitleRef.scrollWidth) {
      setRerender(!rerender);
    }
  }, [gpTitleRef]);
  useEffect(() => {
    if (!gpDescRef) return;
    if (!gpDescRef.scrollHeight) {
      setRerender(!rerender);
    }
  }, [gpDescRef]);

  const infoAreaStyle = {
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    flex: 1,
    width: "100%",
  };
  const titleBoxStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mt: !mobileView && "0.5rem",
    mb: tabletView ? "0.75rem" : "1rem",
  };
  const gpTextStyle = {
    width: "calc(100% - 2.5rem)",
    fontSize: desktopView ? "1.25rem" : "1rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
  const ticketBoxStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: blue[1],
    borderRadius: "10px",
    width: "2.5rem",
    height: "1.25rem",
  };
  const entriesTextStyle = {
    fontWeight: 500,
    color: white,
    fontSize: "0.75rem",
    lineHeight: 1,
    ml: "0.25rem",
  };
  const gpDescContainerStyle = {
    height: !desktopView ? "auto" : inCarousel ? "88px" : "108px",
    overflow: "hidden",
    pb: "0.25rem",
  };
  const compInfoTextStyle = {
    lineHeight: 1.5,
    fontWeight: 400,
    display: "-webkit-box",
    WebkitLineClamp: !desktopView ? 10 : inCarousel ? 5 : 6,
    WebkitBoxOrient: "vertical",
    ...(!desktopView && {
      whiteSpace: "pre-line",
    }),
  };
  const buttonContainerStyle = {
    display: "flex",
    mt: desktopView ? "auto" : tabletView ? "1rem" : "0.5rem",
  };
  const baseButtonStyle = {
    py: "0.5rem",
    px: 0,
    color: green[2],
    background: "transparent",
    textTransform: "none",
    fontWeight: 600,
  };
  const termsButtonStyle = {
    ...baseButtonStyle,
    ...(desktopView
      ? { color: purple[1], mr: "1.5rem" }
      : { ml: "1.5rem", order: 1 }),
  };
  const seeMoreButtonStyle = {
    ...baseButtonStyle,
    px: desktopView ? "0" : "0.75rem",
    color: desktopView ? green[2] : white,
    background: desktopView ? "transparent" : green[2],
  };

  return (
    <Box sx={infoAreaStyle}>
      <Box sx={titleBoxStyle}>
        <Typography ref={setGpTitleRef} variant="h2" sx={gpTextStyle}>
          {gp?.name}
        </Typography>
        <Box sx={ticketBoxStyle}>
          <TicketIcon style={{ width: "15px" }} />
          <Typography sx={entriesTextStyle}>{gp?.entries}</Typography>
        </Box>
      </Box>
      <Box ref={setGpDescRef} sx={gpDescContainerStyle}>
        <Typography variant="body1" sx={compInfoTextStyle}>
          {gp?.description}
        </Typography>
      </Box>
      <Box sx={buttonContainerStyle}>
        <Button
          href="https://saferoadschallenge.com/terms-of-use/"
          sx={termsButtonStyle}>
          {t("termsAndConditions")}
        </Button>
        {(gpDescRef?.scrollHeight > gpDescRef?.clientHeight ||
          gpTitleRef?.scrollWidth > gpTitleRef?.clientWidth) && (
          <Box>
            <Button sx={seeMoreButtonStyle} onClick={handleLearnMore}>
              {t("seeMore")}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default GrandPrizeInfoArea;
